<h1 mat-dialog-title>Hola {{data?.nombre}}</h1>
<h3>¿Es Correcta Esta Información?</h3>
<mat-dialog-content class="mat-typography">
  <h3>Sexo: {{data?.sexo==='1' ? 'Femenino' : 'Masculino'}}</h3>

  <h3>Entidad Federativa: {{entidad?.descripcion}}</h3>

  <h3>Empresa: {{data?.empresa}}</h3>

  <h3>Ocupación Actual: {{ocupacion?.descripcion}}</h3>

  <h3>Teléfono: {{data?.telefono}}</h3>

  <h3>Correo Electónico: {{data?.email}}</h3>

  <h3>Fecha de la cita: {{fecha}} - {{hora?.descripcion}}</h3>

  <h3>Motivo: {{data?.descripcion}}</h3>

</mat-dialog-content>
<div style="width: 100%; text-align: center">
  <mat-card-actions>
    <button mat-raised-button (click)="onNoClick()" color="primary" style="position: relative;
    right: 10px;">No Enviar</button>
    <button mat-raised-button (click)="onClick()" cdkFocusInitial color="primary" [disabled]="proceso">Enviar</button>
  </mat-card-actions>
</div>